"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectors = require("../../../../../redux/selectors");
var _constants = require("../../../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FilterItem = exports.FilterItem = /*#__PURE__*/(0, _react.memo)(_ref => {
  var _tI$item$translationK;
  let {
    item = {}
  } = _ref;
  const isChecked = (0, _reactRedux.useSelector)((0, _selectors.getFiltrationByKey)(item.key));
  const tI = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return /*#__PURE__*/_react.default.createElement(_paulCorePackage.CheckboxListItem, {
    name: item.key,
    checked: isChecked,
    labelPlacement: "start",
    label: (_tI$item$translationK = tI[item.translationKey]) !== null && _tI$item$translationK !== void 0 ? _tI$item$translationK : /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
      variant: "text",
      sx: {
        fontSize: 'inherit',
        width: 100
      }
    }),
    type: "CheckboxListItem",
    disabled: item.disabled || false
  });
});
FilterItem.propTypes = {
  item: _propTypes.default.shape({
    id: _propTypes.default.number.isRequired,
    key: _propTypes.default.oneOf(Object.values(_constants.pipesTypes)).isRequired,
    translationKey: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
    disabled: _propTypes.default.bool
  }).isRequired
};